module.exports = __webpack_public_path__ + "img/linodelke-black.058df1a0.svg";